/* Shared XWERKS purchase controller. Catalog facts come only from Liquid. */
(() => {
  if (customElements.get('xwerks-purchase')) return;
  class XwerksPurchase extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.data = JSON.parse(this.querySelector('[data-purchase-data]').textContent);
      this.form = this.querySelector('form.xp-form');
      this.variant = this.data.variants.find(v => v.id === this.data.initialVariant && v.available) || this.data.variants.find(v => v.available) || this.data.variants[0];
      this.planId = this.data.initialPlan;
      this.mode = (this.data.defaultSubscription || this.data.requiredPlan) && this.variant.plans.length ? 'sub' : 'one';
      this.qty = this.variant.min || 1;
      this.busy = false;
      this.money = new Intl.NumberFormat(this.data.locale, { style: 'currency', currency: this.data.currency });
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      const params = new URLSearchParams(location.search);
      if (params.has('selling_plan')) {
        const found = this.variant.plans.find(p => String(p.id) === params.get('selling_plan'));
        if (found) { this.planId = found.id; this.mode = 'sub'; }
        else if (!this.requiresPlan()) this.mode = 'one';
      }
      const variantSelect = this.querySelector('[data-variant-select]');
      variantSelect.removeAttribute('name');
      this.cartVariant = document.createElement('input');
      this.cartVariant.type = 'hidden'; this.cartVariant.name = 'id';
      this.form.append(this.cartVariant);
      const variants = this.querySelector('[data-variant-buttons]');
      if (variants) { variants.hidden = false; variantSelect.hidden = true; }
      this.addEventListener('click', e => this.onClick(e), opts);
      this.addEventListener('change', e => this.onChange(e), opts);
      this.form.addEventListener('submit', e => { e.preventDefault(); this.addSelected(); }, opts);
      variantSelect.value = String(this.variant.id);
      this.renderPlans();
      this.render();
      if (params.has('variant') && params.get('variant') !== String(this.variant.id)) this.updateURL();
      const sticky = this.querySelector('[data-sticky]');
      if (sticky && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          sticky.hidden = !show;
          sticky.inert = !show;
          sticky.classList.toggle('is-shown', show);
        });
        this.observer.observe(this.querySelector('[data-add-main]'));
      }
      this.querySelectorAll('[data-gallery-image]').forEach(button => {
        button.setAttribute('aria-label', button.querySelector('img')?.alt || this.data.labels.images || 'Product image');
        button.setAttribute('aria-pressed', String(button.classList.contains('is-active')));
      });
    }
    disconnectedCallback() {
      this.controller?.abort(); this.observer?.disconnect(); this.initialized = false;
      this.cartVariant?.remove();
    }
    $(selector) { return this.querySelector(selector); }
    $$(selector) { return [...this.querySelectorAll(selector)]; }
    format(cents) { return this.money.format(cents / 100); }
    requiresPlan() { return this.data.requiredPlan || this.variant.requiresPlan; }
    selectedPlan() { return this.variant.plans.find(p => p.id === Number(this.planId)); }
    bundle() { return this.$('[data-bundle-id][data-plan-card="' + this.mode + '"]'); }
    status(message) { this.$('[data-purchase-status]').textContent = message; }
    onClick(event) {
      const variantButton = event.target.closest('[data-variant-id]');
      if (variantButton) {
        this.chooseVariant(Number(variantButton.dataset.variantId)); return;
      }
      const gallery = event.target.closest('[data-gallery-image]');
      if (gallery) {
        this.setImage(gallery.dataset.img);
        this.$$('[data-gallery-image]').forEach(b => {
          b.classList.toggle('is-active', b === gallery); b.setAttribute('aria-pressed', String(b === gallery));
        });
        return;
      }
      const quantityButton = event.target.closest('[data-quantity-change]');
      if (quantityButton) {
        this.setQuantity(this.qty + Number(quantityButton.dataset.quantityChange) * (this.variant.step || 1)); return;
      }
      const pair = event.target.closest('[data-pair-id]');
      if (pair) { this.addItems([{id: Number(pair.dataset.pairId), quantity: 1}], pair); return; }
      const card = event.target.closest('[data-plan-card]');
      if (card && !event.target.closest('select') && !card.querySelector('input').disabled) {
        this.mode = card.dataset.planCard; this.status(''); this.render(); this.updateURL();
      }
    }
    onChange(event) {
      if (event.target.matches('[data-frequency]')) {
        this.planId = Number(event.target.value); this.mode = 'sub'; this.render(); this.updateURL();
      } else if (event.target.matches('[data-variant-select]')) {
        this.chooseVariant(Number(event.target.value));
      } else if (event.target.matches('[data-quantity]')) {
        this.setQuantity(Number(event.target.value));
      } else if (event.target.name === 'purchase_option') {
        this.mode = event.target.value; this.render(); this.updateURL();
      }
    }
    chooseVariant(id) {
      const variant = this.data.variants.find(v => v.id === id);
      if (!variant || !variant.available) {
        this.$('[data-variant-select]').value = String(this.variant.id);
        return;
      }
      const previousPlan = this.selectedPlan();
      this.variant = variant;
      const nextPlan = variant.plans.find(p => p.id === this.planId) || variant.plans.find(p => p.name === previousPlan?.name) || variant.plans[0];
      this.planId = nextPlan?.id;
      if (!variant.plans.length && !this.requiresPlan()) this.mode = 'one';
      if (this.requiresPlan()) this.mode = 'sub';
      this.qty = variant.min || 1;
      this.$('[data-variant-select]').value = String(id);
      this.status(''); this.renderPlans(); this.render(); this.updateURL();
    }
    setImage(url) {
      const image = this.$('[data-main-image]');
      if (!image || !url) return;
      image.removeAttribute('srcset'); image.src = url;
    }
    renderPlans() {
      const select = this.$('[data-frequency]');
      select.replaceChildren(...this.variant.plans.map(plan => {
        const option = document.createElement('option'); option.value = plan.id; option.textContent = plan.name; return option;
      }));
      if (!this.selectedPlan()) this.planId = this.variant.plans[0]?.id;
      select.value = String(this.planId || '');
    }
    setQuantity(value) {
      const min = this.variant.min || 1, step = this.variant.step || 1;
      let next = Number.isFinite(value) ? Math.max(min, Math.round((value - min) / step) * step + min) : min;
      if (this.variant.max) next = Math.min(next, this.variant.max);
      this.qty = next; this.render();
    }
    updateURL() {
      const url = new URL(location.href);
      url.searchParams.set('variant', String(this.variant.id));
      if (this.mode === 'sub' && this.selectedPlan()) url.searchParams.set('selling_plan', String(this.planId));
      else url.searchParams.delete('selling_plan');
      history.replaceState({}, '', url);
    }
    render() {
      const plan = this.selectedPlan(), bundle = this.bundle();
      const available = bundle ? bundle.dataset.bundleAvailable === 'true' : this.variant.available && (this.mode !== 'sub' || !!plan);
      const unit = bundle ? Number(bundle.dataset.bundlePrice) : this.mode === 'sub' && plan ? plan.price : this.variant.price;
      const total = unit * this.qty;
      this.cartVariant.value = bundle ? bundle.dataset.bundleId : this.variant.id;
      this.$('[data-frequency]').disabled = this.mode !== 'sub' || !plan || !!bundle;
      this.$('[data-plan-card="sub"]').hidden = !this.variant.plans.length;
      this.$('[data-plan-card="one"]').hidden = this.requiresPlan();
      this.$$('[data-plan-card]').forEach(card => {
        const active = card.dataset.planCard === this.mode;
        card.classList.toggle('is-active', active); card.querySelector('input').checked = active;
      });
      this.$$('[data-variant-id]').forEach(button => {
        const variant = this.data.variants.find(v => v.id === Number(button.dataset.variantId));
        button.disabled = !variant?.available;
        button.setAttribute('aria-disabled', String(button.disabled));
        const active = !button.disabled && variant.id === this.variant.id;
        button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active));
      });
      this.$$('[data-selected-title]').forEach(el => { el.textContent = this.variant.title; });
      this.$$('[data-total-price]').forEach(el => { el.textContent = this.format(total); });
      this.$$('[data-add-label]').forEach(el => { el.textContent = this.busy ? this.data.labels.adding : available ? this.data.labels.add : this.data.labels.soldOut; });
      this.$$('[data-add-main],[data-add-sticky]').forEach(button => { button.disabled = this.busy || !available; button.setAttribute('aria-busy', String(this.busy)); });
      const quantity = this.$('[data-quantity]');
      quantity.value = this.qty; quantity.min = this.variant.min || 1; quantity.step = this.variant.step || 1;
      if (this.variant.max) quantity.max = this.variant.max; else quantity.removeAttribute('max');
      this.$('[data-one-price]').textContent = this.format(this.variant.price);
      this.$('[data-one-unit]').textContent = this.format(this.variant.price / Math.max(1, this.data.servings));
      if (plan) {
        this.$('[data-sub-price]').textContent = this.format(plan.price);
        this.$('[data-sub-unit]').textContent = this.format(plan.price / Math.max(1, this.data.servings));
        const compare = this.variant.price;
        this.$('[data-sub-compare]').textContent = this.format(compare);
        this.$('[data-sub-compare]').hidden = compare <= plan.price;
        const saving = compare > 0 ? Math.round((compare - plan.price) / compare * 100) : 0;
        this.$('[data-saving]').textContent = saving > 0 ? saving + '% ' + this.data.labels.off : '';
        this.$('[data-saving]').hidden = saving <= 0;
      }
      this.$('[data-payment-terms]').hidden = this.mode !== 'one' || this.qty !== 1;
      const shipping = this.$('[data-shipping-note]');
      shipping.hidden = !this.data.shippingThreshold;
      const gap = this.data.shippingThreshold - total;
      shipping.textContent = gap > 0 ? this.data.labels.shippingGap.replace('[amount]', this.format(gap)) : this.data.labels.shippingFree;
    }
    async addSelected() {
      if (this.busy || this.$('[data-add-main]').disabled) return;
      const item = { id: Number(this.cartVariant.value), quantity: this.qty };
      if (this.mode === 'sub') {
        const plan = this.selectedPlan(); if (!plan) return;
        item.selling_plan = plan.id;
      }
      await this.addItems([item]);
    }
    async addItems(items, sourceButton) {
      if (this.busy) return;
      this.busy = true; this.status(''); this.render();
      if (sourceButton) sourceButton.disabled = true;
      try {
        if (window.cart && typeof window.cart.add === 'function') {
          const result = await window.cart.add({items}, true);
          if (result?.status >= 400) throw new Error(result.description || result.message || this.data.labels.error);
        } else {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.data.labels.error);
          location.assign(root + 'cart'); return;
        }
        this.status(this.data.labels.added);
      } catch (error) {
        this.status(error.message || this.data.labels.error);
      } finally {
        this.busy = false; this.render(); if (sourceButton) sourceButton.disabled = false;
      }
    }
  }
  customElements.define('xwerks-purchase', XwerksPurchase);
})();
